import {
  CompletePageConditionalRuleModel,
  CompletePageConditionalRuleResponse,
} from '@/domain/model/forms'
import { CompletePageType } from '@/pages/Contexts/FormBuilderContext'
import { transformFromCompleteConditionalRuleResponse } from '@/utils/conditionalCompletePage/transformFromCompleteConditionalRuleResponse'

type InitializeDataProps = {
  conditionalRuleData?: CompletePageConditionalRuleResponse[]
  previousState?: CompletePageType
  editedData: CompletePageConditionalRuleModel
  hasMissingOrder: boolean
}
export const editConditionalRuleInitializeData = ({
  conditionalRuleData,
  previousState,
  editedData,
  hasMissingOrder,
}: InitializeDataProps) => {
  const responseData =
    transformFromCompleteConditionalRuleResponse(conditionalRuleData) || []

  return {
    ...previousState,
    data: responseData.map((item, index) => {
      if (String(item.id) === String(editedData.id)) {
        return {
          ...editedData,
          order: hasMissingOrder ? index + 1 : editedData.order,
        }
      }
      return {
        ...item,
        order: hasMissingOrder ? index + 1 : item.order,
        is_updated: hasMissingOrder,
      }
    }),
  }
}

type ExistsDataProps = {
  previousState?: CompletePageType
  editedData: CompletePageConditionalRuleModel
  hasMissingOrder: boolean
  oldData: CompletePageConditionalRuleModel[]
}
export const editConditionalRuleItemExists = ({
  previousState,
  editedData,
  hasMissingOrder,
  oldData,
}: ExistsDataProps) => {
  return {
    ...previousState,
    data: oldData.map((item, index) => {
      if (String(item.id) === String(editedData.id)) {
        return {
          ...editedData,
          order: hasMissingOrder ? index + 1 : editedData.order,
        }
      }
      return {
        ...item,
        order: hasMissingOrder ? index + 1 : item.order,
        is_updated: hasMissingOrder,
      }
    }),
  }
}
